import { render, staticRenderFns } from "./DetailedArticle.vue?vue&type=template&id=598ea1ee&scoped=true&"
import script from "./DetailedArticle.vue?vue&type=script&lang=js&"
export * from "./DetailedArticle.vue?vue&type=script&lang=js&"
import style0 from "./DetailedArticle.vue?vue&type=style&index=0&id=598ea1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ea1ee",
  null
  
)

export default component.exports